/**
 * App-level screen registry. Lives in shell/navigation by convention.
 *
 * This barrel re-exports screen components from every feature module's public-api.
 * It is NOT a bidirectional coupling between shell and feature modules — shell
 * only references the screen components for navigation routing, and feature
 * modules import cross-cutting services (auth, session, connectivity) from
 * shell/public-api. The dependency direction is: feature → shell (services),
 * registry → feature (screens). No cycle exists at the module level.
 *
 * See issue #836 for context.
 */
export { BranchSelectionScreen, LoginScreen, BranchSetupScreen, OnboardingScreen, OfflineSetupRequired } from '../../auth/public-api';
export { EmployeePermissionsScreen, TeamHubScreen, InviteEmployeeScreen } from '../../team/public-api';
export {
  ActivityHistoryScreen,
  TeamHistoryScreen,
  ArcaIntegrationScreen,
  BillingScreen,
  ActivateCreceScreen,
  CreceSuccessScreen,
  BranchSettingsScreen,
  BranchIdentityScreen,
  BranchPosOpsScreen,
  BranchDevicesScreen,
  StorefrontHubScreen,
  DeliverySettingsScreen,
  IntegrationsHubScreen,
  ManageBranchesScreen,
  MercadoPagoBranchSettingsScreen,
  ProfileScreen,
  MarketplaceTrustScreen,
  OrganizationScreen,
  ChangeBusinessTypeScreen,
  BusinessFunctionsScreen,
  OperationModeScreen,
  CapabilityBreakdownScreen,
  AddFeaturesScreen,
  MySupportReportsScreen,
  SupportTicketDetailScreen,
  CashManagementScreen,
  GlossaryScreen,
} from '../../settings/public-api';
export { CatalogScreen } from '../../catalog/screenExports';
export { InventoryScreen } from '../../inventory/screenExports';
export { PosScreen } from '../../pos/public-api';
export { ReportsScreen } from '../../reports/public-api';
export { CustomersScreen } from '../../customers/public-api';
export { FollowUpInboxScreen } from '../../customers/public-api';
export { SaleDetailScreen } from '../../sales/public-api';
export { SalesListScreen } from '../../sales/public-api';
export { PromotionsListScreen } from '../../promotions/public-api';
export { PriceListsListScreen } from '../../priceLists/public-api';
export { OwnerBranchesPanelScreen, OwnerPanelHomeCard, useOwnerPanelAccess } from '../../owner-panel/public-api';
export { MoreHubScreen } from './screens/MoreHubScreen';
export { ExpensesScreen } from '../../expenses/public-api';
export { PurchasesScreen } from '../../purchases/screens/PurchasesScreen';
export { OnlineOrdersScreen } from '../../orders/public-api';
export { OnlineComplaintsScreen } from '../../complaints/public-api';
export { StoreReviewsScreen, StoreReviewDetailScreen } from '../../store-reviews/public-api';
export { ConsultationsScreen, ConsultationDetailScreen } from '../../consultations/public-api';
export { QuotesScreen, QuoteDetailScreen } from '../../quotes/public-api';
export { AppointmentsScreen, AppointmentResourcesScreen } from '../../appointments/public-api';
export { WorkOrdersScreen, WorkOrderDetailScreen, WorkOrderFormScreen, CommissionsScreen } from '../../work-orders/public-api';
export { CommissionsScreen as CommissionsDashboardScreen, MyCommissionsScreen, CommissionPlansScreen, SettlementDetailScreen, BoothRentalsScreen } from '../../commissions/public-api';
export { CommissionsHubScreen } from './screens/CommissionsHubScreen';
export { PricingHubScreen } from './screens/PricingHubScreen';
export { CatalogHubScreen } from './screens/CatalogHubScreen';
export { SettingsHubScreen } from './screens/SettingsHubScreen';
export { StorefrontZoneScreen } from './screens/StorefrontZoneScreen';
export { VehiclesScreen, VehicleFormScreen, ServiceRemindersScreen, VehicleHistoryScreen } from '../../vehicles/public-api';
export { AiChatScreen } from '../../ai/screens/AiChatScreen';

export { LoyaltyProgramScreen } from '../../loyalty/public-api';
